import moment from 'moment';
import { INote } from '~/utils/interface/note';
import { IExportPayrollOption } from '../interface/payroll';

export const mockDataNotesTimeClock: INote[] = [
  {
    id: '1',
    createdBy: '1',
    avatarImage:
      'https://images.unsplash.com/photo-1742403949587-42a767b9ea5b?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    content:
      'Est laboris et eiusmod pariatur irure proident id excepteur ipsum. Duis adipisicing non aute nostrud minim incididunt nostrud excepteur. Excepteur nostrud et tempor aliqua. Cillum cillum exercitation ullamco sint pariatur do fugiat quis est anim. Occaecat aliquip qui do fugiat culpa id. Aliqua ipsum pariatur elit ipsum tempor. Tempor sit magna irure minim do ullamco amet minim laborum laborum aliqua. Eiusmod irure anim quis in. Ea exercitation sunt fugiat nisi elit aute id tempor. Consequat aliqua dolor proident ut amet nulla. Labore id excepteur sit magna nostrud id quis ad. Cillum dolor cillum nostrud et voluptate dolore minim est nisi laborum. Non ea consequat sunt aute laboris et sit qui esse adipisicing.',
    createdAt: '2025-03-29T00:00:00.000Z',
    firstName: 'Elara',
    lastName: 'Monroe',
  },
  {
    id: '2',
    createdBy: '41',
    avatarImage:
      'https://images.unsplash.com/photo-1742403949587-42a767b9ea5b?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    content:
      'Cupidatat velit proident magna occaecat adipisicing. Consectetur minim eu proident qui non sunt ullamco voluptate nulla exercitation reprehenderit sunt nostrud pariatur. Est officia sint sunt eiusmod anim cillum enim aliqua.',
    createdAt: '2025-04-18T00:00:00.000Z',
    firstName: 'David',
    lastName: 'Hug',
  },
  {
    id: '3',
    createdBy: '1',
    avatarImage:
      'https://images.unsplash.com/photo-1742403949587-42a767b9ea5b?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    content:
      'Duis consequat laborum duis exercitation irure nisi ex nisi fugiat nulla. Qui et anim reprehenderit aliquip magna consequat culpa. Fugiat pariatur proident id do commodo ullamco officia excepteur reprehenderit sint pariatur nisi. Nisi anim laborum Lorem sint veniam ullamco. Minim minim proident laborum dolore veniam deserunt ut aliqua consectetur.',
    createdAt: '2025-05-21T00:00:00.000Z',
    firstName: 'Sophia',
    lastName: 'Alice',
  },
];

export const dataMonthExport: IExportPayrollOption[] = Array.from({ length: 12 }, (_, index) => {
  const startOfMonth = moment().month(index).startOf('month').startOf('day').toISOString();
  const endOfMonth = moment().month(index).endOf('month').endOf('day').toISOString();
  const monthName = moment().month(index).format('MMMM');

  return {
    label: monthName,
    value: monthName.toUpperCase(),
    startTime: startOfMonth,
    endTime: endOfMonth,
  };
});
